import DropZone from 'react-dropzone';
import type { DropzoneOptions } from 'react-dropzone';

import { plural } from '../../../../shared/helpers/plural';
import Button from '../../generic/Button/Button';
import ButtonGroup from '../../generic/Button/ButtonGroup';
import Flex from '../../generic/Flex';
import { icons, IconText } from '../../generic/Icon';

type UploadHeaderProps = {
  numUploads: number;
  onDropAdditionalFiles: DropzoneOptions['onDrop'];
  acceptedFileTypes: Record<string, string[]>;
  onUpload: () => void;
  isUploadEnabled: boolean;
};

const UploadComponentHeader = ({
  numUploads,
  onDropAdditionalFiles,
  acceptedFileTypes,
  isUploadEnabled,
  onUpload,
}: UploadHeaderProps) => (
  <Flex direction="row" grow={1} justify="flex-end">
    <ButtonGroup spacing="lg">
      <DropZone
        onDrop={onDropAdditionalFiles}
        accept={acceptedFileTypes}
      >
        {
          ({ getRootProps, getInputProps }) => (
            <>
              <span className="add-uploads-wrapper" {...getRootProps()}>
                <IconText
                  icon={icons.plus}
                  text="Add Files"
                />
              </span>
              <input {...getInputProps()} />
            </>
          )
        }
      </DropZone>
      <Button
        type="primary"
        size="large"
        icon={icons.upload}
        isDisabled={!isUploadEnabled || numUploads === 0}
        onClick={onUpload}
      >
        <IconText
          icon={icons.caretRight}
          text={`Upload ${numUploads} ${plural(numUploads, 'file')}`}
          alignIcon="right"
        />
      </Button>
    </ButtonGroup>
  </Flex>
);

export default UploadComponentHeader;
